import { useEffect } from 'react'
import {
  RadioField,
  OrderJourneyContent,
  DeliveryOptions as DeliveryOptionsComponent,
} from '@sh24/ui-components'
import { useRouter } from 'next/router'
import getQuestionInfo from '../../../utils/get-question-info'
import useTranslations from '../../../utils/use-translations'
import { camelizeObject } from '../../../utils/helpers'
import replaceTranslationTokens from '../../../utils/replace-translation-tokens'
import formatDeliveryOption from './format-delivery-option'

const DeliveryOptions = ({
  question,
  contextKey,
  context,
  dispatch,
}) => {
  const currency = 'GBP'
  const { locale } = useRouter()
  const translations = useTranslations()
  const { postcode } = context
  const selectedMethod = context[contextKey]
  const selectionKey = `${contextKey}Selection`
  const selectedOption = context[selectionKey]
  const fulfilmentOptions = context.fulfilment_options || {}
  const {
    postal_available: postalAvailable,
    collection_available: collectionAvailable,
  } = fulfilmentOptions
  const methodErrors = context?.errors?.[contextKey] || []
  const selectionErrors = context?.errors?.[selectionKey] || []
  const { infoTop, infoBottom } = getQuestionInfo(context, question)
  const deliveryOptions = fulfilmentOptions[selectedMethod]
  const allMethods = question.options?.map((opt) => ({
    ...opt,
    details: null,
  })) || []

  const availableMethods = allMethods.filter(({ value }) => {
    if (value === 'postal' && postalAvailable) return true
    if (value === 'collection' && collectionAvailable) return true
    return false
  })

  const onChangeMethod = (e) => {
    dispatch(contextKey, e.target.value)
    const newOptions = fulfilmentOptions[e.target.value]
    const newSelection = newOptions.length === 1 ? newOptions[0] : null
    dispatch(selectionKey, camelizeObject(newSelection))
  }

  const onChangeOption = (e) => {
    const option = deliveryOptions.find((opt) => parseInt(opt.id, 10) === parseInt(e.target.value, 10))
    dispatch(selectionKey, camelizeObject(option))
  }

  useEffect(() => {
    if (!selectedMethod && availableMethods.length === 1) {
      onChangeMethod({ target: { value: availableMethods[0].value } })
    }
  }, [])

  const formattedOptions = deliveryOptions?.map((opt) => (
    formatDeliveryOption(
      opt,
      selectedMethod,
      translations,
      locale,
      currency,
    )
  ))

  const postcodeCopy = postcode
    ? replaceTranslationTokens({
      translations,
      translationKey: 'deliveryOption.postcodeInfo',
      values: [postcode.toUpperCase()],
    }) : null

  return (
    <OrderJourneyContent>
      <div>
        <RadioField
          id={question.id}
          title={question.title}
          label={question.label}
          infoTop={infoTop}
          infoBottom={infoBottom}
          selected={selectedMethod}
          options={availableMethods}
          onChange={onChangeMethod}
          errors={methodErrors}
        />

        {formattedOptions && (
          <div className="mb-md">
            {postcodeCopy && (
              <div className="mb-md body-sm">
                {postcodeCopy}
              </div>
            )}

            <DeliveryOptionsComponent
              options={formattedOptions}
              onChange={onChangeOption}
              selected={selectedOption?.id}
              errors={selectionErrors}
            />
          </div>
        )}
      </div>
    </OrderJourneyContent>
  )
}

export default DeliveryOptions
